import { track } from 'utils/tracking';
import { ITrackingProductPageBaseParameters } from '../shared/baseParameters';
import { fillItems, ITrackingFillItemsParameters } from '../shared/fillItems';
import {
  fillRewardCampaign,
  ITrackingFillRewardCampaignParameters,
} from '../shared/fillRewardCampaign';

export const trackProductDetailsRewardDetailsExpandOrCollapse = (
  parameters: {
    sectionTitle: string;
    isCollapsed: boolean;
  } & Pick<ITrackingProductPageBaseParameters, 'leadId'> &
    ITrackingFillItemsParameters &
    ITrackingFillRewardCampaignParameters,
): void => {
  const { sectionTitle, isCollapsed, leadId } = parameters;

  return track({
    event: 'product_interaction',
    component_type: 'accordion',
    component_title: `Product Details Overlay/Reward Details/${sectionTitle}_${isCollapsed ? 'See Less' : 'See More'}`,
    action: isCollapsed ? 'collapse' : 'expand',
    item_list_name: 'apply form',
    ...fillItems(parameters),
    step_number: '1',
    step_name: 'lead-submission',
    lead_id: leadId,
    ...fillRewardCampaign(parameters),
  });
};
